import styled from 'styled-components';
import media from '../../../constants/media';
import { Column } from '../../base/grid';
import DynamicRspImage from '../../base/images/dynamicRspImageBg';
import { A, H2, H5 } from '../../base/typography';

export const ComponentWrapper = styled.div``;
export const ContentWrapper = styled.div`
	display: flex;
	gap: 13.6rem;
	flex-direction: column;
	${media.tablet`
		gap: 9rem;
		flex-direction: row;
	`};
`;
export const ContentColumn = styled(Column)`
	flex: 13;
	order: 1;

	padding: 0;
	margin: 0;
  width: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    max-width: 100%;
    margin: 0 24px;
    height: auto;
    object-fit: cover;
    margin-bottom: 16px;
    border-radius: 24px;

    ${media.tablet`
      max-width: 80%;
      margin: 0 0;
      margin-bottom: 16px;
    `};
  }
    p {
      color: ${({ theme }) => theme.colors.grey6};
      line-height: 32px;
      ${media.tablet`
        font-size: 18px;
      `};
    }
`;

export const Gutter = styled(Column)`
	flex: 7;
	order: 2;
	padding: 0;
	margin: 0;
`;

export const ArticleTitle = styled(H2)`
	margin-bottom: 16px;
  justify-self: center;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.SharpSlab};
  max-width: 100%;
  font-weight: 700;
  font-size: 32px;
  line-height: 119%;
  letter-spacing: -1px;

	${media.desktopSmall`
		max-width: 60%;
    margin-top: 8px;
    font-size: 64px;
    letter-spacing: -1.9px;
	`};
`;

export const ArticleImage = styled(DynamicRspImage)`
	width: 100%;
	height: 45rem;
	object-fit: cover;
	margin-bottom: 4rem;
  border-radius: 24px;
`;

export const ArticleAuthorWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 4.5rem;
`;

export const ArticleAuthorImage = styled(DynamicRspImage)`
	width: 7.2rem;
	height: 7.2rem;
	border-radius: 100%;
	margin-right: 3.2rem;
`;

export const ArticleAuthorContent = styled.div`
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-size: 1.8rem;
	color: ${({ theme }) => theme.colors.graySummary};
`;

export const ArticleAuthorName = styled(H5)``;

export const ArticleAuthorTitle = styled.span`
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-size: 1.4rem;
	color: ${({ theme }) => theme.colors.graySummary};
`;

export const ArticleAuthorEmail = styled(A)``;

export const GutterColumns = styled(Column)`
	flex-direction: columns;
	padding: 0;
	margin: 0;
`;

export const ArticleDate = styled.div`
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-size: 1.4rem;
	color: ${({ theme }) => theme.colors.graySummary};
	margin-bottom: 2rem;

  ${media.tablet`
    max-width: 60%;
    margin-top: 2rem;
  `};
`;

export const ArticleSummary = styled(H5)`
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
  font-size: 18px;
	line-height: 140%;
	margin-bottom: 40px;
	color: ${({ theme }) => theme.colorsV2.mainDark};
  text-align: center;
  ${media.tablet`
    max-width: 60%;
    font-size: 20px;
    line-height: 150%;
    margin-bottom: 64px;
  `};
`;

export const ArticleContent = styled.div`
  display: flex;
	flex-direction: column;
	align-items: center;
  ${media.tablet`
    max-width: 60%;
  `};
`;

export const TagList = styled.div`
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-weight: 700;
	margin-bottom: 3rem;
	color: ${({ theme }) => theme.colors.secondary};
`;

export const LinkContainer = styled.div`
  margin-top: 40px;
  margin-bottom: -110px;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;

  ${media.desktopSmall`
    margin-top: 48px;
    max-width: 60%;
    width: 60%;
    justify-self: center;
    margin-bottom: 22px;
    font-size: 18px;
  `}
`;